/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://25mm7gtldnam3kxmdcinazt77m.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-qbm6iufutfd4tinevxnd5tmjni",
    "aws_cognito_identity_pool_id": "us-east-1:de5d64f8-80b3-4bd8-837c-56cc54be1b67",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_9pWxtiuVI",
    "aws_user_pools_web_client_id": "6bpv3up549ua0m4lfp4rb01db4",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "NAME",
        "BIRTHDATE"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "geo": {
        "amazon_location_service": {
            "region": "us-east-1",
            "maps": {
                "items": {
                    "mape1cfc1e0-prod": {
                        "style": "VectorEsriStreets"
                    }
                },
                "default": "mape1cfc1e0-prod"
            }
        }
    }
};


export default awsmobile;
